export const buildUseStargateAccountQueryKey = () => ["USE_STARGATE_ACCOUNT"];
